export var HeaderDictionaryEs = {
  welcomeMessage: 'Bienvenidos, {{office_name}}',
  lastLogin: 'Último acceso, {{last_login}}'
};